<div id="landing" class="landing background-image">
    <div class="pt-3">
        <div class="px-5">
            <!-- prod -->
            <!-- <div class="row align-items-center justify-content-center mx-0 h-100vh m-auto">
                <div class="col-md-6 col-12 hide-mobile py-3 px-3 m-auto ">
                    <div class="px-5 img-inner text-center">
                        <img src="./assets/images/landing2.png" alt="Landingpage" class="">
                    </div>
                </div>
                <div class="col-md-6 col-12 text-center mobile-view m-auto">
                    <div class="mobileposition text-center">
                        <div class="logo w-15 m-auto">
                            <img src="./assets/images/botlogo.png" alt="Bot Logo" class="img-block">
                        </div>
                        <div class="py-3 ft-16 text-secondary m-auto">
                            The central dashboard for your AliceBlue Account
                        </div>
                        <div class="login-Ant py-4 mb-3">
                            <a class="bg-darkblue ft-14 text-light p-3 text-decoration-none rounded cursor" (click)="loginWithANT()">Login with ANT</a>
                        </div>
                        <div class="sigin ft-14 text-secondary ">
                            Don't have a account?
                            <a href="https://aliceblueonline.com/open-account-fill-kyc-request-call-back"
                                target="_blank" class="ft-14 text-primary fw-bold text-decoration-none cursor">Sign Up
                            </a>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- uat -->
            <!-- <div class="row mx-0 align-items-center text-center h-100vh">
                <div class="col-md-7 text-center hide-mobile m-auto">
                    <div class=" h-100">
                        <div class="w-80 m-auto d-flex align-items-center">
                            <img src="./assets/images/landing_new.png" alt="" class="">
                        </div>
                    </div>
                </div>
                <div class="col-1 px-0 h-100 border-darkblue hide-mobile b-left"></div>
                <div class="col-md-4 text-center">
                    <div class="">
                        <div class="logo w-15 m-auto">
                            <img src="./assets/images/botlogo.png" alt="Bot Logo" class="img-fluid">
                        </div>
                        <div class="py-3 ft-16 text-secondary text-center">
                            The central dashboard for your AliceBlue Account
                        </div>
                        <div class="login-Ant py-4 mb-3">
                            <a class="bg-darkblue ft-14 text-light p-3 text-decoration-none rounded cursor"
                                (click)="loginWithANT()">Login with ANT</a>
                        </div>
                        <div class="sigin ft-14 text-secondary ">
                            Don't have a account?
                            <a href="https://aliceblueonline.com/open-account-fill-kyc-request-call-back"
                                target="_blank" class="ft-14 text-primary fw-bold text-decoration-none cursor">Sign Up
                            </a>
                        </div>
                    </div>
                </div>
            </div> -->

            <!--New Code -->

            <!-- <div class="row align-items-center  mx-0 h-100vh m-auto">
                <div class="col-md-8 col-12 hide-mobile mt-10 px-3">
                    <div class="px-5 img-inner text-end pe-5">
                        <div class="pe-5">

                            <img src="./assets/images/banner-cont.png" alt="Landingpage" class="">
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12 text-center mobile-view">
                    <div class="mobileposition ">
                        <div class="text-left">
                            <img src="./assets/images/bot-img2.png" alt="Bot Logo" class="img-fluid w-0 pb-1 w-50" width="100">
                        </div>
                        <div class="pb-2 pt-n4 pt-md-3 ft-16 text-secondary new-t1">
                            The central dashboard for your AliceBlue Account
                        </div>
                        <div class="login-Ant py-4 mb-3 new-t2">
                            <a class="bg-darkblue ft-14 text-light p-3 text-decoration-none rounded cursor" (click)="loginWithANT()">Login with ANT</a>
                        </div>
                        <div class="sigin ft-14 pt-n5 text-secondary new-t3">
                            Don't have a account?
                            <a href="https://aliceblueonline.com/open-account-fill-kyc-request-call-back"
                                target="_blank" class="ft-14 text-primary fw-bold text-decoration-none cursor">Sign Up
                            </a>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Diwali -->

            <!-- <div class="row mx-0 h-100vh m-auto">
                <div class="col-md-8 col-12 hide-mobile mt-10 px-3">
                    <div class="px-5 img-inner text-end pe-5">
                        <div class="pe-5">
                           
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12 text- mobile-view">
                    <div class="mobileposition-d">
                        <div class="text-left">
                            <img src="./assets/images/diwali.gif" alt="Bot Logo" class="img-fluid w-0 pb-1 w-25" width="100">
                                
                        </div>
                        <div class="pb-2 pt-n4 pt-md-3 ft-16 text-secondary new-t1">
                            The central dashboard for your AliceBlue Account
                        </div>
                        <div class="login-Ant py-4 mb-3 new-t2">
                            <a class="bg-darkblue ft-14 text-light p-3 text-decoration-none rounded cursor"
                                (click)="loginWithANT()">Login with ANT</a>
                        </div>
                        <div class="sigin ft-14 pt-n5 text-secondary new-t3">
                            Don't have a account?
                            <a href="https://aliceblueonline.com/open-account-fill-kyc-request-call-back"
                                target="_blank" class="ft-14 text-primary fw-bold text-decoration-none cursor">Sign Up
                            </a>
                        </div>
                    </div>
                </div>
                <div class="mobile-con text-center">
                    <div class="mobileposition mobile-content">
                        <div class="text-center d-flex justify-content-center align-items-center w-100">
                           
                            <img src="./assets/images/diwali.gif" alt="Bot Logo" class="" >
                        </div>
                        <div class="pb-2 pt-n4 pt-md-3 ft-16 text-secondary new-t1">
                            The central dashboard for your AliceBlue Account
                        </div>
                        <div class="login-Ant py-4 mb-3 new-t2">
                            <a class="bg-darkblue ft-14 text-light p-3 text-decoration-none rounded cursor" (click)="loginWithANT()">Login with ANT</a>
                        </div>
                        <div class="sigin ft-14 pt-n5 text-secondary new-t3">
                            Don't have a account?
                            <a href="https://aliceblueonline.com/open-account-fill-kyc-request-call-back"
                                target="_blank" class="ft-14 text-primary fw-bold text-decoration-none cursor">Sign Up
                            </a>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Christmas -->
            <!-- <div class="row mx-0 h-100vh m-auto">
                <div class="col-md-8 col-12 hide-mobile mt-10 px-3">
                    <div class="px-5 img-inner text-end pe-5">
                        <div class="pe-5">
                           
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="mobileposition-d ">
                        <div class="text-left">
                            <img src="./assets/images/botlogo.png" alt="Bot Logo" class="img-fluid w-0 pb-1 w-25" width="100">
                                
                        </div>
                        <div class="pb-2 pt-n4 pt-md-3 ft-16 text-secondary new-t1">
                            The central dashboard for your AliceBlue Account
                        </div>
                        <div class="login-Ant py-4 mb-3 new-t2">
                            <a class="bg-darkblue ft-14 text-light p-3 text-decoration-none rounded cursor"
                                (click)="loginWithANT()">Login with ANT</a>
                        </div>
                        <div class="sigin ft-14 pt-n5 text-secondary new-t3">
                            Don't have a account?
                            <a href="https://aliceblueonline.com/open-account-fill-kyc-request-call-back"
                                target="_blank" class="ft-14 text-primary fw-bold text-decoration-none cursor">Sign Up
                            </a>
                        </div>
                    </div>
                </div>
                <div class="mobile-con text-center">
                    <div class="mobileposition mobile-content">
                        <div class="text-center d-flex justify-content-center align-items-center w-100">
                           
                            <img src="./assets/images/botlogo.png" alt="Bot Logo" class="" >
                        </div>
                        <div class="pb-2 pt-3 pt-md-3 ft-14 text-secondary new-t1">
                            The central dashboard for your AliceBlue Account
                        </div>
                        <div class="login-Ant py-4 mb-3 new-t2">
                            <a class="bg-darkblue ft-14 text-light p-3 text-decoration-none rounded cursor" (click)="loginWithANT()">Login with ANT</a>
                        </div>
                        <div class="sigin ft-12 pt-n5 text-secondary new-t3">
                            Don't have a account?
                            <a href="https://aliceblueonline.com/open-account-fill-kyc-request-call-back"
                                target="_blank" class="ft-12 text-primary fw-bold text-decoration-none cursor">Sign Up
                            </a>
                        </div>
                    </div>
                </div>
            </div>  -->


            <!-- new year -->
            <div class="row mx-0 align-items-center text-center h-100vh">
                <div class="col-12 d-flex justify-content-center align-items-center col-md-8 text-center ">
                    <!-- <img src="./assets/images/newyear.png" alt="NewYear"> -->
                    <img src="./assets/images/landing2.png" alt="Holding image view">
                </div>
                <div class="col-md-4 text-center">
                    <div>
                        <div class="logo w-15 m-auto">
                            <img src="./assets/images/botlogo.png" alt="Bot Logo" class="img-fluid"> 
                        </div>
                        <div class="py-3 ft-16 text-secondary text-center">
                            The central dashboard for your <b>AliceBlue Account</b>
                        </div>
                        <div class="login-Ant py-4 mb-3">
                            <a class="bg-darkblue ft-14 text-light p-3 text-decoration-none rounded cursor"
                                (click)="loginWithANT()">Login with ANT</a>
                        </div>
                        <div class="sigin ft-14 text-secondary ">
                            Don't have a account?
                            <a href="https://aliceblueonline.com/open-account-fill-kyc-request-call-back"
                                target="_blank" class="ft-14 text-primary fw-bold text-decoration-none cursor">Sign Up
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
 <app-app-accessibility-panel></app-app-accessibility-panel>
</div>
<!--  -->

<ngx-loading [show]="loading">Loading...</ngx-loading>
